import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// Sociallink - Get All (Read)
export const GetAll = createAsyncThunk(
    "masters/sociallink/get-all",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Masters.Social_link}?term=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Sociallink - Get (Read)
export const GetSingle = createAsyncThunk(
    "masters/social-link/get",
    async (id, { rejectWithValue }) => {
        try {
            const res = await GET(`${APIS.Masters.Social_link}/${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Sociallink - Create (Add)
export const Create = createAsyncThunk(
    "masters/social-link/create",
    async (data, { rejectWithValue }) => {
        try {
            const res = await POST(APIS.Masters.Social_link, data);
            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);// The new sociallink object
        } catch (error) {
            console.error(error, 'error');

            return rejectWithValue(error);
        }
    }
);

// Sociallink - Update
export const Update = createAsyncThunk(
    "masters/social-link/update",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await PUT(`${APIS.Masters.Social_link}/${id}`, data);
            return res;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// Sociallink - Delete
export const Delete = createAsyncThunk(
    "masters/social-link/delete",
    async (id, { rejectWithValue }) => {
        try {
            const data = await DELETE(`${APIS.Masters.Social_link}/${id}`);
            return id; // Return the id of the deleted sociallink
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Sociallink - Status
export const Status = createAsyncThunk(
    "masters/social-link/status",
    async (id, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.Masters.Social_link}/${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const Slice = createSlice({
    name: "sociallink",
    initialState: {
        data: [],
        current_page: IDS.PAGE,
        total_pages: IDS.TOTALPAGES,
        per_page: IDS.PERPAGE,
        total: IDS.TOTAL,
        status: IDS.SLICESTATUS.Idle,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handling all actions for GetSingle, Create, Update, Delete
            .addCase(GetAll.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAll.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.data = action.payload?.data?.data || [];
                state.current_page = action.payload?.data?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
                state.total = action.payload?.data?.total || IDS.TOTAL;
            })
            .addCase(GetAll.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetSingle.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetSingle.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
            })
            .addCase(GetSingle.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Create.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Create.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data.unshift(action.payload.data);
            })
            .addCase(Create.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Update.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Update.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                const index = state.data.findIndex(
                    (sociallink) => sociallink.id === action.payload?.data?.id
                );
                if (index !== -1) {
                    state.data[index] = action.payload.data;
                }
            })
            .addCase(Update.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Delete.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Delete.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data = state.data.filter(
                    (sociallink) => sociallink.id !== action.payload.id
                ); // Remove the sociallink with the deleted id
            })
            .addCase(Delete.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            //
            .addCase(Status.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Status.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data = state.data.filter(
                    (sociallink) => sociallink.id !== action.payload.id
                ); // Remove the sociallink with the deleted id
            })
            .addCase(Status.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            });
    },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
